module.exports = __webpack_public_path__ + "img/max-register-step-3.0795c02c.png";